/**
 * Auth.js - Main Authentication Component
 *
 * This component serves as the container for the authentication system, providing a tabbed interface
 * that allows users to switch between Login and Signup forms. It uses Material-UI components for
 * a consistent and responsive design.
 *
 * Key Features:
 * - Tabbed interface for switching between Login and Signup
 * - Responsive layout with centered content
 * - Clean and modern UI design
 *
 * @component
 * @example
 * <Auth />
 */

import React, { useState } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import Login from "./Login";
import Signup from "./Signup";

const Auth = () => {
  // State to track which tab is currently active (0 for Login, 1 for Signup)
  const [value, setValue] = useState(0);

  // Handler for tab changes
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    // Main container with centered content
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "90vh",
      }}
    >
      {/* Authentication form container with styling */}
      <Box
        sx={{
          width: 500,
          border: "1px solid #33333",
          borderRadius: "8px",
          boxShadow: 1,
          padding: "10px",
        }}
      >
        {/* Tab navigation */}
        <Tabs value={value} onChange={handleChange} centered>
          <Tab label="Login" />
          <Tab label="Signup" />
        </Tabs>
        {/* Conditional rendering of Login or Signup component based on active tab */}
        {value === 0 && (
          <Box sx={{ p: 3 }}>
            <Typography component="div">
              <Login />
            </Typography>
          </Box>
        )}
        {value === 1 && (
          <Box sx={{ p: 3 }}>
            <Typography component="div">
              <Signup />
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Auth;
